import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { ArquivoService } from '../../shared/services/arquivo.service';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  AbstractControl,
  Validators
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { AuthService } from '../../admin/auth.service';
import { Usuario } from '../../../models/usuario';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'emprego-na-pistaalterar-arquivo',
  templateUrl: './alterar-arquivo.component.html',
  styleUrls: ['./alterar-arquivo.component.css']
})
export class AlterarArquivoComponent extends WebPage implements OnInit {
  uploadUrl: string;
  form: FormGroup;
  idCandidato;
  idArquivo;
  tipoArquivo;
  arquivo;
  usuario: Usuario;
  get arquivos() {
    return this.form.get('arquivos') as FormArray;
  }

  constructor(
    messageService: MessageService,
    private fb: FormBuilder,
    private _router: Router,
    private route: ActivatedRoute,
    private arquivoService: ArquivoService,
    private confirmationService: ConfirmationService,
    private authService: AuthService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params => {
      this.idCandidato = params.get('idCandidato');
      this.idArquivo = params.get('idArquivo');

      this.form = this.fb.group({
        motivoAlteracao: [null, Validators.required],
        arquivos: new FormArray([])
      });
    });

    this.usuario = this.authService.informacoesUsuario();
  }

  ngOnInit() {
    this.getArquivo();
  }

  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;
    // console.log(idArquivo);
    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo
    });
    this.arquivos.push(arquivoFormGroup);
    // console.log(this.arquivos);
  }

  uploadError(mensagem) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: mensagem
    });
    this.isLoading = false;
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
         let arquivosNovos: AbstractControl[];
         arquivosNovos = this.arquivos.controls.filter(arquivo => !arquivo.value.isOld);
         this.removeArquivosDoBanco(arquivosNovos);

         this._router.navigate(['/visualizar-historico', this.idCandidato]);
      }
    });
  }

  getArquivo() {
    this.arquivoService
      .getArquivo(this.idArquivo)
      .finally(() => (this.isLoading = false))
      .subscribe(
        arquivo => {
          this.arquivo = arquivo;
          console.log(arquivo);
          this.urlUpload(arquivo.idTipoArquivo);
        },
        error => this.gerenciaErro(error)
      );
  }

  urlUpload(idTipoArquivo) {
    // console.log(idTipoArquivo.toUpperCase());
    switch (idTipoArquivo.toUpperCase()) {
      case '3AD2F54E-1EC6-45FF-B3FF-1B85D3763DF5':
        this.tipoArquivo = 'documentoIdentificacao';
        break;
      case 'F53F1A1E-DDBE-406E-B208-DC9D2E4C287E':
        this.tipoArquivo = 'certidaoNadaConstaProntuario';
        break;
      case 'DF6908EC-1C21-49B3-9524-11403D6667BA':
        this.tipoArquivo = 'comprovanteResidencia';
        break;
      case '5AC24F1B-4ABE-448B-BAC5-AE09CA2783C0':
        this.tipoArquivo = 'comprovanteVinculo';
        break;
      case '4D38F07A-D0F7-475B-9D6F-87572BCE3420':
        this.tipoArquivo = 'editalFase';
        break;
      case '3262F9E9-771D-481C-AE8C-87E3D524EE4B':
        this.tipoArquivo = 'editalCredenciamento';
        break;
      case 'F678C376-4CE5-42A1-8C67-B566002CBFE7':
        this.tipoArquivo = 'termoCredenciamento';
        break;
      case '8116730F-A7E0-4B19-B05A-85F908C8D07A':
        this.tipoArquivo = 'documentoLaboratorio';
        break;
      case '5DBC2069-9B6A-43B9-9717-26266F808E73':
        this.tipoArquivo = 'justificativaReagendamento';
        break;
      case '5AC24F1B-4ABE-448B-BAC5-AE09CA2783C0':
        this.tipoArquivo = 'resultadoExameToxicologico';
        break;
      case '9AA398DD-16C8-47D6-911F-5101AA282CAB':
        this.tipoArquivo = 'resultadoExameMedicoPsicologico';
        break;
      case '7AB3BADB-C542-4AFC-9EAF-D65B6D9D713C':
        this.tipoArquivo = 'resultadoCursoPratico';
        break;
      case '53187DE7-F2C7-4EA5-93CC-F5E99354C498':
        this.tipoArquivo = 'resultadoProvaPratica';
        break;
      default:
        this.tipoArquivo = '';
    }
    this.uploadUrl = this.arquivoService.uploadUrlAlterar + this.tipoArquivo;
  }

  downloadArquivo(idArquivo, nomeArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, nomeArquivo);
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));
    this.isLoading = true;
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = false)
      .subscribe(
        () => {},
        error => this.gerenciaErro(error)
    );
  }

  submit() {
    // console.log(this.form.value);
    if (this.form.value.arquivos.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Arquivo não inserido'
      });
      return;
    }

    if (this.form.value.motivoAlteracao === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'O Campo motivo alteração é obrigatório!'
      });
      return;
    }

    const arquivoAlterado = {
      idCandidato: this.idCandidato,
      idArquivo: this.form.value.arquivos[0].idArquivo,
      idUsuarioAlteracao: this.usuario.IdUsuario,
      motivoAlteracao: this.form.value.motivoAlteracao,
      idArquivoAnterior: this.idArquivo
    };

    // console.log(arquivoAlterado);

    this.confirmationService.confirm({
      message: 'Deseja mesmo atualizar este arquivo?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.arquivoService
        .cadastrarArquivoAlterado(arquivoAlterado)
        .finally(() => (this.isLoading = false))
        .subscribe(
          () => {
            this._router.navigate(['/visualizar-historico', this.idCandidato]);
          },
          error => this.gerenciaErro(error)
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/alterar-arquivo/alterar-arquivo.component.ts